import { SectionWrap } from "@/components/Section";
import { useReveal } from "@/hooks/useReveal";
import { Sparkles, Layers, Cpu, TrendingUp } from "lucide-react";

const ITEMS = [
  {
    icon: Layers,
    k: "Materials",
    v: "Soft, biocompatible substrates are now achievable at lab scale.",
  },
  {
    icon: Cpu,
    k: "AI maturity",
    v: "Physics-aware, interpretable models are production-ready.",
  },
  {
    icon: Sparkles,
    k: "Compute",
    v: "High-density, real-time signal pipelines are finally feasible.",
  },
  {
    icon: TrendingUp,
    k: "Frontier",
    v: "Neurotechnology is the next venture-grade research frontier.",
  },
];

export function WhyNowBand() {
  useReveal();
  return (
    <SectionWrap id="why-now" className="!py-20 lg:!py-24">
      <div className="reveal flex items-center gap-3 mb-8">
        <span className="section-num">01.5</span>
        <span className="h-px w-10 bg-white/15" />
        <span className="section-num !text-[#38BDF8]">Why Now</span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/5 border border-white/5 rounded-2xl overflow-hidden">
        {ITEMS.map(({ icon: Icon, k, v }, i) => (
          <div
            key={i}
            className="reveal bg-[#07111F] p-7 group hover:bg-[#0B1628] transition-colors"
            style={{ transitionDelay: `${i * 60}ms` }}
          >
            <div className="flex items-center justify-between">
              <Icon
                size={18}
                strokeWidth={1.6}
                className="text-[#38BDF8] group-hover:scale-110 transition-transform"
              />
              <span className="font-mono text-[10px] tracking-[0.3em] text-[#475569]">
                0{i + 1}
              </span>
            </div>
            <div className="mt-5 font-mono text-[10px] uppercase tracking-[0.28em] text-[#BFDBFE]">
              {k}
            </div>
            <p className="mt-2 text-[#CBD5E1] text-[14px] leading-relaxed">
              {v}
            </p>
          </div>
        ))}
      </div>
    </SectionWrap>
  );
}
